import { TYPES } from 'action-types/equipments';
import {
    IEquipmentDetail, EmptyEquipmentDetail, IEquipmentHeader, IEquipmentHeaderEmpty, IEquipmentDetailsCostAndRevenue
} from './models';

interface IAction {
    readonly type: string;
    readonly response: IEquipmentDetail;
    readonly equipmentHeader: IEquipmentHeader;
    readonly equipments: any;
    readonly errors: string;
    readonly equipmentCostAndRevenueSplits: IEquipmentDetailsCostAndRevenue[];
}
export interface IEquipmentState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly isAccessDenied: boolean;
    readonly detailsPendingError: string;
    readonly response: IEquipmentDetail;
    readonly equipmentHeader: IEquipmentHeader;
    readonly equipmentCostAndRevenueSplits: IEquipmentDetailsCostAndRevenue[];
    readonly equipments: any
}

export const defaultState: IEquipmentState = {
    isFetchDataLoading: false,
    isFetchDataError: false,
    isAccessDenied: false,
    detailsPendingError: '',
    response: EmptyEquipmentDetail,
    equipments: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    equipmentHeader: IEquipmentHeaderEmpty,
    equipmentCostAndRevenueSplits: []
}

export const reducer = (state: IEquipmentState = defaultState, action: IAction): IEquipmentState => {
    switch (action.type) {
        case TYPES.RESET_EQUIPMENTS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                detailsPendingError: ''
            };
        case TYPES.RESET_EQUIPMENTS.FULFILLED:
            return {
                ...state,
                equipments: action.equipments && action.equipments.length === 0 ?  defaultState.equipments: action.equipments
            };
        case TYPES.FETCH_EQUIPMENTS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                response: defaultState.equipments
            };
        case TYPES.FETCH_EQUIPMENTS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                equipments: action.equipments && action.equipments.result ? action.equipments: defaultState.equipments
            };
        case TYPES.FETCH_EQUIPMENTS.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EQUIPMENTS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EQUIPMENT_DETAILS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isAccessDenied: false,
                isFetchDataLoading: true,
                detailsPendingError: ''
            };
        case TYPES.EQUIPMENT_ACCESS_DENIED:
            return {
                ...state,
                isFetchDataLoading: false,
                isAccessDenied: true
            };
        case TYPES.FETCH_EQUIPMENT_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                response: action.response
            };
        case TYPES.FETCH_EQUIPMENT_DETAILS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EQUIPMENT_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        
            case TYPES.FETCH_EQUIPMENT_HEADER.PENDING:
                return {
                    ...state,
                    isFetchDataError: false,
                    isFetchDataLoading: true,
                    detailsPendingError: ''
                };
            case TYPES.FETCH_EQUIPMENT_HEADER.FULFILLED:
                return {
                    ...state,
                    isFetchDataLoading: false,
                    equipmentHeader: action.equipmentHeader
                };
            case TYPES.FETCH_EQUIPMENT_HEADER.REJECTED:
                return {
                    ...state,
                    isFetchDataLoading: false,
                    isFetchDataError: true,
                    detailsPendingError: action.errors
                };
            case TYPES.FETCH_EQUIPMENT_HEADER.RESET_ERROR:
                return {
                    ...state,
                    isFetchDataLoading: false,
                    isFetchDataError: true,
                    detailsPendingError: action.errors
                };


                case TYPES.FETCH_EQUIPMENT_CHARGES.PENDING:
                    return {
                        ...state,
                        isFetchDataError: false,
                        isFetchDataLoading: true,
                        detailsPendingError: '',
                        equipmentCostAndRevenueSplits: defaultState.equipmentCostAndRevenueSplits
                    };
                case TYPES.FETCH_EQUIPMENT_CHARGES.FULFILLED:
                    return {
                        ...state,
                        isFetchDataLoading: false,
                        equipmentCostAndRevenueSplits: action.equipmentCostAndRevenueSplits
                    };
                case TYPES.FETCH_EQUIPMENT_CHARGES.REJECTED:
                    return {
                        ...state,
                        isFetchDataLoading: false,
                        isFetchDataError: true,
                        detailsPendingError: action.errors
                    };
                case TYPES.FETCH_EQUIPMENT_CHARGES.RESET_ERROR:
                    return {
                        ...state,
                        isFetchDataLoading: false,
                        isFetchDataError: true,
                        detailsPendingError: action.errors
                    };
        default:
            return state;
    }
};
